import { Component } from '@angular/core';

import { AuthUserService } from '../../services/auth-user-service/auth-user.service';
import { TokenStorageService } from '../../services/auth-user-service/token-storage.service';

import { MatSidenav } from '@angular/material/sidenav';

@Component({
  selector: 'authzone-side-menu',
  templateUrl: './authzone-side-menu.component.html',
  styleUrls: ['./authzone-side-menu.component.css']
})
export class AuthzoneSideMenuComponent {
  private rol: number = 0;
  public links = [
    { target: '/dashboard', icon: 'home', 'description': 'Home' },
    { target: '/vehicles', icon: 'commute', 'description': 'Vehicles' },
    { target: '/accidents', icon: 'car_crash', 'description': 'Accidents' },
    { target: '/licenses', icon: 'description', 'description': 'Licenses' },
    { target: '/insurances', icon: 'assignment_ind', 'description': 'Insurances' },
    { target: '/inspections', icon: 'engineering', 'description': 'Inspections' },
    { target: '/owners', icon: 'badge', 'description': 'Owners' },
    { target: '/busstops', icon: 'directions_bus', 'description': 'Bus stops' },
    { target: '/users', icon: 'person', 'description': 'Users' },
    { target: '/login', icon: 'login', 'description': 'Login'
    }
   ];

  public logOut() {
    this.authUserService.logout();
  }

  constructor(private authUserService: AuthUserService, private tokenStorage: TokenStorageService) {
    this.rol = this.tokenStorage.getRol();
  }
}
